export enum ColumnKeys {
  EVENT_TYPE = 'event_type',
  CATEGORY = 'category',
  SENSOR_TYPE = 'sensor_type',
  OS_TYPES = 'os_types',
  STATUS = 'status',
  REQUIREMENTS = 'requirements',
  COMPANY = 'companyId',
}

export enum Column {
  EVENT_TYPE = 0,
  CATEGORY = 1,
  SENSOR_TYPE = 2,
  OS_TYPES = 3,
  STATUS = 4,
  REQUIREMENTS = 5,
  COMPANY = 6,
}

export enum OS {
  WINDOWS = 0,
  LINUX = 1,
  MAC = 2,
}

export enum Sensors {
  ENDPOINT = 'endpoint',
  OFFICE365 = 'office365',
}

export interface EventMapping {
  [ColumnKeys.EVENT_TYPE]: FrontendEventTypes;
  [ColumnKeys.CATEGORY]: FrontendEventCategories;
  [ColumnKeys.OS_TYPES]: Array<OS>;
  [ColumnKeys.REQUIREMENTS]: Array<FrontendRequirements>;
}

export interface RawEventConfigGridItem extends EventMapping {
  // Since we don't have an actual row for each config
  // (each entry is an entry in a nested object) we can use the key from
  // that object as a key
  id: string;
  eventTypeRawName: string; // TODO maybe change type
  [ColumnKeys.SENSOR_TYPE]: Sensors;
  [ColumnKeys.STATUS]: Statuses;
}

export enum EndpointEventType {
  CREATE_PROCESS = 'CreateProcess',
  TERMINATE_PROCESS = 'TerminateProcess',
  INJECTION_PROCESS = 'ProcessInjection',
  CREATE_FILE = 'CreateFile',
  DELETE_FILE = 'DeleteFile',
  MODIFY_FILE = 'ModifyFile',
  READ_FROM_FILE = 'ReadFromFile',
  MOVE_FILE = 'MoveFile',
  REGISTRY_CREATE_KEY = 'RegCreateKey',
  REGISTRY_DELETE_KEY = 'RegDeleteKey',
  REGISTRY_DELETE_VALUE = 'RegDeleteValue',
  REGISTRY_MODIFY_VALUE = 'RegModifyValue',
  LOGON = 'Logon',
  LOGOUT = 'Logout',
  LOGON_FAILED = 'LogonFailed',
  NETWORK_CONNECTION = 'NetworkConnection',
  SERVICE_ADDED = 'ServiceAdded',
  USER_ACCOUNT_SETTINGS_CHANGED = 'UserAccountSettingsChanged',
  SCHEDULED_TASK_CREATE = 'ScheduledTaskCreate',
  SCHEDULED_TASK_MODIFY = 'ScheduledTaskModify',
  SCHEDULED_TASK_DELETE = 'ScheduledTaskDelete',
  SERVICE_CHANGE_STATUS = 'ServiceChangeStatus',
  SERVICE_MODIFY = 'ServiceModify',
  AMSI_BUFFER = 'AMSIBuffer',
}

export enum Office365EventType {
  MAIL = 'Mail',
}

/**
 * All event categories that are shown in the grid, form all sensors
 */
export enum FrontendEventCategories {
  PROCESS = 'Process',
  FILE = 'File',
  REGISTRY = 'Registry',
  USER = 'User',
  NETWORK = 'Network',
  SERVICE = 'Service',
  SCHEDULED_TASK = 'Scheduled task',
  O365 = 'O365',
}

/**
 * All event types that are shown in the grid, from all sensors
 */
export enum FrontendEventTypes {
  CREATE = 'Create',
  TERMINATE = 'Terminate',
  INJECTION = 'Injection',
  DELETE = 'Delete',
  MODIFY = 'Modify',
  READ = 'Read',
  MOVE = 'Move',
  CREATE_KEY = 'Create key',
  DELETE_KEY = 'Delete key',
  DELETE_VALUE = 'Delete value',
  MODIFY_VALUE = 'Modify value',
  LOG_ON = 'Logon',
  LOG_OUT = 'Logout',
  LOG_ON_FAILED = 'Logon failed',
  CONNECTION = 'Connection',
  ADDED = 'Added',
  USER_SPECIFIC = 'User specific',
  SECURITY_CENTER = 'Security center',
  SETTINGS_CHANGED = 'Settings changed',
  CHANGE_STATUS = 'Change status',
  O365_MAIL = 'O365 Mail',
  AMSI_BUFFER = 'AMSI Buffer',
}

export enum FrontendRequirements {
  DEFAULT = 'DEFAULT',
  O365_MAIL = 'O365_MAIL',
  SERVICE_ADDED = 'SERVICE_ADDED',
  USER_LOGON_FAILED = 'USER_LOGON_FAILED',
  USER_ACCOUNT_SETTINGS_CHANGE = 'USER_ACCOUNT_SETTINGS_CHANGE',
  SCHEDULE_TASk_CREATE = 'SCHEDULE_TASK_CREATE',
  SCHEDULE_TASK_DELETE = 'SCHEDULE_TASK_DELETE',
  SCHEDULE_TASK_MODIFY = 'SCHEDULE_TASK_MODIFY',
  AMSI_BUFFER = 'AMSI_BUFFER',
}

export enum Statuses {
  FILTERED = 'filtered',
  DISABLED = 'disabled',
}

export interface RawConfig {
  [sensorName: string]: {
    [eventType: string]: string;
  };
}
